import { ColocaStatusPill } from "@/shared/components/data-display/ColocaStatusPill";
import useTranslations from "@/shared/lang/useTranslations";

import {
  RESCUE_PILL_VARIANT,
  RESCUE_STATUS_LABEL_KEYS,
  RESCUE_STATUS_LONG_KEYS,
} from "../constants/payoutRescue.constants";
import type { PayoutStatus } from "../services/payoutRescue.service";

export interface RescueStatusPillProps {
  status: PayoutStatus | string;
  /** Long-form wording for the drawer header ("Requiere rescate"); default is the short table label. */
  long?: boolean;
  size?: "default" | "sm";
  withDot?: boolean;
}

/**
 * Payout status pill in the rescue vocabulary: CREATED reads "Por rescatar" (a payout resting in CREATED is
 * an anomaly — auto-dispatch runs inside the create request). Unknown new backend statuses fall back to the
 * raw enum value; CANCELLED renders neutral (deliberate action, never an error).
 */
export function RescueStatusPill({
  status,
  long = false,
  size = "default",
  withDot = true,
}: RescueStatusPillProps) {
  const { t } = useTranslations("payoutRescue");
  const labelKey = (long ? RESCUE_STATUS_LONG_KEYS : RESCUE_STATUS_LABEL_KEYS)[status];
  const variant = RESCUE_PILL_VARIANT[status as PayoutStatus] ?? "neutral";
  return (
    <ColocaStatusPill variant={variant} size={size} withDot={withDot}>
      {labelKey ? t(labelKey) : status}
    </ColocaStatusPill>
  );
}
